<template>
  <div class="tab-list">
    <div
      class="tab-item"
      v-for="(item, key) in menu"
      :key="item"
      :class="{ 'active-item': menuCheckedIdx == key }"
      @click="changeMenuState(key)"
    >
      {{ item }}
      <div class="btm-line" v-show="menuCheckedIdx == key"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    menu: {
      type: Object,
      required: true
    },
    menuCheckedIdx: {
      type: Number,
      default: 0,
    }
  },
  setup(props, context) {
    const changeMenuState = (idx) => {
      context.emit('update:menuCheckedIdx', Number(idx));
    };

    return {
      changeMenuState
    };
  }
};
</script>

<style lang="stylus" scoped>
.tab-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 44px;
  background: #fff;

  .tab-item {
    position relative
    display: flex;
    align-items: center;
    height: 44px;
    font-size: 16px;
    color: #999;
    font-weight: 400;

    .btm-line {
      position absolute
      bottom 0
      left calc(50% - 9px)
      width: 18px;
      height: 3px;
      background: #FF9645;
      border-radius: 2px;
    }
  }

  .active-item {
    font-size: 18px;
    color: #191919;
    font-weight: 500;
  }
}
</style>
